import moment, { Moment } from "moment";
import { CheckInStatus } from "./enum/checkInStatus";
import { EventCategory } from "./enum/EventCategory";

export interface CheckInSummaryDto {
  eventId: number;
  eventCategoryType: string;
  eventStartAt?: string;
  eventEndAt?: string;
  ticketAvailableStartAt?: string;
  ticketAvailableEndAt?: string;
  eventTitle: string;
  rewardId: number;
  rewardName: string | null;
  checkInStatus: string;
}

export class CheckInSummary {
  eventId: number;
  category: EventCategory;
  eventStartAt?: Moment;
  eventEndAt?: Moment;
  ticketAvailableStartAt?: Moment;
  ticketAvailableEndAt?: Moment;
  title: string;
  rewardId: number;
  rewardName: string | null;
  status: CheckInStatus;

  constructor(data: CheckInSummaryDto) {
    this.eventId = data.eventId;
    this.category =
      EventCategory[data.eventCategoryType as keyof typeof EventCategory];
    this.eventStartAt = data?.eventStartAt
      ? moment(data.eventStartAt)
      : undefined;
    this.eventEndAt = data?.eventEndAt ? moment(data.eventEndAt) : undefined;
    this.ticketAvailableStartAt = data?.ticketAvailableStartAt
      ? moment(data.ticketAvailableStartAt)
      : undefined;
    this.ticketAvailableEndAt = data?.ticketAvailableEndAt
      ? moment(data.ticketAvailableEndAt)
      : undefined;
    this.title = data.eventTitle;
    this.rewardId = data.rewardId;
    this.rewardName = data.rewardName;
    this.status =
      CheckInStatus[data.checkInStatus as keyof typeof CheckInStatus];
  }
}
